import React from "react";
import {OrbitComponent} from "../../../../../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {
    IGameContextViewModel
} from "../../../../../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {GamePlayPcHeaderBarComponent} from "../../game-play-pc-header-bar.component";

interface UkGamePlayPcHeaderBarComponentProps {
    gameContext: IGameContextViewModel;
}

export const UkGamePlayPcHeaderBarComponent = observer(
    class UkGamePlayPcHeaderBarComponent extends OrbitComponent<UkGamePlayPcHeaderBarComponentProps> {
        render() {
            return (
                <GamePlayPcHeaderBarComponent gameContext={this.props.gameContext}/>
            );
        }
    }
);
